import { withAccessRights } from "lcm-iot-commons";
import ResellerCustomerCreateEdit from "./ResellerCustomerCreateEdit";

export const validateAccessRights = (accessRights: $TSFixMe) =>
  accessRights.canUpdate;

type ResellerCustomerEditAccessRightsProps = {
  match: {
    params?: {
      id?: string;
    };
  };
};

export function ResellerCustomerEditAccessRights({
  match,
}: ResellerCustomerEditAccessRightsProps) {
  return <ResellerCustomerCreateEdit match={match} />;
}
export default withAccessRights(
  // @ts-expect-error TS(2345) FIXME: Argument of type '({ match, }: ResellerCustomerEdi... Remove this comment to see the full error message
  ResellerCustomerEditAccessRights,
  "Customer",
  validateAccessRights,
);
